<template>
  <ResponsiveLayout>
    <BaseBanner
      role="alert"
      variant="warning"
      :title="$t('generic__error_title')"
      data-qa="generic-error-page"
    />
  </ResponsiveLayout>
</template>

<script setup>
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import BaseBanner from '@shared/components/BaseBanner.vue'
</script>
